import type { VesselSubType, VesselSuperType } from './all-ship-types';
import { Dimensions } from './maritime-ais-api';
import type { MergedFeaturePoint } from './merged-feature-point.model';

export enum VesselSource {
  AIS = 'AIS',
  RISK_INTELLIGENCE = 'RISK_INTELLIGENCE',
  RFGL = 'RFGL',
  GLOBAL_AIS = 'GLOBAL_AIS',
}

export interface Vessel extends Partial<MergedFeaturePoint> {
  vessel_id: string;
  name: string;
  imo?: number | string;
  mmsi?: number | string;
  heading?: number;
  latitude: number;
  longitude: number;
  callsign: string;
  vessel_sub_type?: VesselSubType;
  vessel_super_type?: VesselSuperType;
  flag?: string;
  // TODO: these should be numbers, but Alerts API returns string and History API returns number...
  course: number;
  speed?: number;
  dimensions?: Dimensions;
  source: VesselSource;
  timestamp?: string | number;
}

export interface VesselPort extends Vessel {
  alertType?: string;
  additionalDetails?: {
    port_details: Object;
    before_message: { timestamp: string };
    after_message: { latitude: number; longitude: number; timestamp: number };
  };
}

export interface VesselV2FormItem {
  mmsi: string;
  imo: string;
}
